import { render } from "./LicenseStatusEmailConfirmationModal.vue?vue&type=template&id=22f63fbc"
import script from "./LicenseStatusEmailConfirmationModal.vue?vue&type=script&lang=js"
export * from "./LicenseStatusEmailConfirmationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__